const projects = [
  {
    id: 1,
    cardImg: '/images/roshambo.png',
    projectLink: 'https://anthonyheinrichs.github.io/odin-roshambo/',
    title: 'Roshambo',
    languages: 'JS, HTML5, CSS3',
    description: 'A Rock, paper and scissors game. You play against the computer in a best of 7 to determine a winner.',
  },
  {
    id: 2,
    cardImg: '/images/etchasketch.png',
    projectLink: 'https://anthonyheinrichs.github.io/odin-etch-a-sketch/',
    title: 'Etch-A-Sketch',
    languages: 'JS, HTML5, CSS3',
    description: "The grid will change colors while hovering your mouse, depending on what colors or modes you have selected.",
  },
  {
    id: 3,
    cardImg: '/images/calculator.png',
    projectLink: 'https://anthonyheinrichs.github.io/odin-calculator/',
    title: 'Calculator',
    languages: 'JS, HTML5, CSS3',
    description: 'A calculator application. You can use your keyboard to add, subtract or divide numbers.'
  },
  {
    id: 4,
    cardImg: '/images/library.png',
    projectLink: 'https://anthonyheinrichs.github.io/odin-library/',
    title: 'My Bookshelf',
    languages: 'JS, HTML5, CSS3',
    description: 'library application that has a form to add books to a personal library and sort them by read.',
  },
  {
    id: 5,
    cardImg: '/images/tic-tac-toe.png',
    projectLink: 'https://anthonyheinrichs.github.io/odin-tic-tac-toe/',
    title: 'Tic-tac-toe',
    languages: 'JS, HTML5, CSS3',
    description: 'Tic-tac-toe game',
  },
  {
    id: 6,
    cardImg: '/images/weather-app.png',
    projectLink: 'https://anthonyheinrichs.github.io/odin-weather-app/',
    title: 'Weather app',
    languages: 'JS, Webpack, HTML5, CSS3',
    description: 'A weather app that uses the Opean Weather Map API to get current weather and forecast weather for the next 3 days.',
  },
  {
    id: 7,
    cardImg: '/images/battleship.png',
    projectLink: 'https://anthonyheinrichs.github.io/odin-battleship/',
    title: 'Battleship',
    languages: 'JS, Webpack, HTML5, CSS3',
    description: 'A battleship game. First one to sink all of the opposing player\'s ships wins!.',
  },
  {
    id: 8,
    cardImg: '/images/to-do.png',
    projectLink: 'https://anthonyheinrichs.github.io/odin-to-do/',
    title: 'To Do List',
    languages: 'JS, Webpack, HTML5, CSS3',
    description: 'A to-do application where you create projects add your tasks to them.',
  },
  {
    id: 9,
    cardImg: '/images/message-board.png',
    projectLink: 'https://odin-message-app.fly.dev/',
    title: 'Message Board',
    languages: 'Node, Express, MongoDB',
    description: 'A small message board where you can leave a message, designed from my nostalgia of MSN messenger.',
  },
  {
    id: 10,
    cardImg: '/images/memory-card.png',
    projectLink: 'https://odin-memory-card-chi.vercel.app/',
    title: 'Memory Game',
    languages: 'React, Node, Express, MongoDB',
    description: 'A card memory game. Click through cards strategically, testing memory skills to avoid picking the same card twice.',
  }
]

export default projects
